import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import type * as Types from './types';

export const fetchPermissionDescriptions = (institutionId: string, kind: Types.Kind) => {
    return RESTClient.getAuthenticatedObservable('v2/filter/describe', {
        institution: institutionId,
        kind,
    }).map(response =>
        response.children
            .filter(child => child.section === 'childPermission' && child.column === true)
            .map(child => ({
                label: child.name,
                id: child.id,
            })),
    );
};

export const fetchPermissionResults = (
    institutionId: string,
    kind: Types.Kind,
    permissionIds: string[],
    filterValues?: {
        groupId?: string;
    },
) => {
    return RESTClient.getAuthenticatedObservable('v2/filter/results', {
        institution: institutionId,
        kind,
        group: filterValues?.groupId,
        columns: ['name', 'group', ...permissionIds],
        limit: 1000,
        sortby: 'name',
        order: 'ASC',
        status: 'current',
    }).map(response => ({
        total: response.totalChildren,
        results: response.children.map(child => {
            const permissions = Object.keys(child)
                .filter(key => key.startsWith('childpermission:'))
                .map(key => ({[key]: child[key][0]}))
                .reduce(
                    (reduction, permission) => ({
                        ...reduction,
                        ...permission,
                    }),
                    {},
                );

            return {
                childId: child.childId,
                group: {
                    id: child.group[0].id,
                    name: child.group[0].name,
                },
                image: {
                    empty: child.image.empty,
                    large: child.image.large,
                    small: child.image.small,
                },
                name: child.name,
                permissions,
            };
        }),
    }));
};
